//react
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

//components
import ButtonCulture from '../../components/buttonCulture/buttonCulture';
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';

//data
import dataSiteMap from '../../siteMap.json';
import dataExternalSites from '../../externalSites.json';

//assets
import './cultureSelect.css';

class CultureSelect extends Component {
	componentDidMount() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	getCookie(cookieName) {
		cookieName += "=";

		const decodedCookie = decodeURIComponent(document.cookie);
		const cookieArray = decodedCookie.split(';');

		for (const cookie of cookieArray) {
			let currentCookie = cookie;

			while (currentCookie.charAt(0) === ' ') {
				currentCookie = currentCookie.substring(1);
			}
			if (currentCookie.indexOf(cookieName) === 0) {
				return currentCookie.substring(cookieName.length, currentCookie.length);
			}
		}

		return '';
	}

	cultureExists(cultureCode) {
		for (const existingCulture of Object.keys(dataSiteMap)) {
			if (Array.isArray(cultureCode)) {
				if (cultureCode.indexOf(dataSiteMap[existingCulture].cultureCode) >= 0 && dataSiteMap[existingCulture].live) {
					return existingCulture;
				}
			} else {
				if (cultureCode === dataSiteMap[existingCulture].cultureCode && dataSiteMap[existingCulture].live) {
					return existingCulture;
				}
			}
		}

		return false;
	}

	render() {
		const cookieCulture = this.getCookie('culturePreference');

		if (cookieCulture) {
			//cookie culture set so redirect to landing page for that culture if that culture exists
			const cookieCultureCode = this.cultureExists(cookieCulture);

			if (cookieCultureCode) {
				return (
					<Redirect to={'/' + cookieCultureCode} />
				);
			}
		}

		//get cultures from sitemap
		const siteMap = Object.keys(dataSiteMap);
		const cultureData = [];

		for (const culture of siteMap) {
			if (dataSiteMap[culture].live && dataSiteMap[culture].cultureCode !== 'global') {
				cultureData.push({
					cultureCode: culture,
					cultureName: dataSiteMap[culture].cultureName,
					external: false,
				});
			}
		}

		//get cultures from external sites
		const externalSites = Object.keys(dataExternalSites);

		for (const culture of externalSites) {
			if (dataExternalSites[culture].live) {
				cultureData.push({
					cultureCode: culture,
					cultureName: dataExternalSites[culture].cultureName,
					external: dataExternalSites[culture].url,
				});
			}
		}

		const cultureList = cultureData.sort((a, b) => {return (a.cultureName.localeCompare(b.cultureName))}).map((record, index) => {
			return (
				<ButtonCulture external={record.external} key={index} label={record.cultureName} cultureCode={record.cultureCode} />
			);
		});

		return (
			<div className="wrapper">

				<Header />

				<section className="culture-select">
					<div className="container">
						<h1 className="culture-select__title">Please select your country:</h1>
						{cultureList}
					</div>
				</section>

				<Footer isCultureSelect />

			</div>
		);
	}
}

export default CultureSelect;



// WEBPACK FOOTER //
// ./src/pages/cultureSelect/cultureSelect.js